module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.cfa9ce18.svg";